import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import TextField from '~/components/core/Molecules/Fields/TextField';

import { CloseIcon_Deprecated, SearchIcon } from '../../icons';

import styles from './SimpleSearchField.module.scss';

const SimpleSearchField = ({ onChange, label, placeholder, renderClearButton, disableUnderline, className }) => {
  const [id] = useState(_uniqueId('prefix-'));
  const [searchText, setSearchText] = useState('');

  return (
    <TextField
      value={searchText}
      onChange={(value) => {
        setSearchText(value);
        onChange(value);
      }}
      id={id}
      className={className}
      label={label}
      fullWidth
      InputProps={{
        disableUnderline,
        placeholder,
        endAdornment: (
          <>
            {renderClearButton && searchText.length > 0 ? (
              <IconButton
                size="small"
                title="Clear"
                onClick={() => {
                  setSearchText('');
                  onChange('');
                }}
              >
                <CloseIcon_Deprecated height={10} width={10} />
              </IconButton>
            ) : null}
            <SearchIcon size={13} className={styles.searchIcon} />
          </>
        ),
      }}
    />
  );
};

SimpleSearchField.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  renderClearButton: PropTypes.bool,
  disableUnderline: PropTypes.bool,
  className: PropTypes.string,
};

export default SimpleSearchField;
